import type { TastenModus } from "./Tastenfeld"

export interface FeldDef {
  key: string
  label: string
  einheit?: string
  modus: TastenModus | "text"
  /** Nach der ersten Nachkommastelle automatisch ins nächste Feld (Laborwerte wie 35,6) */
  autoWeiter?: boolean
}

export const LABOR_ANF: FeldDef[] = [
  { key: "anf_ist_1", label: "1. Probe", einheit: "%", modus: "zahl", autoWeiter: true },
  { key: "anf_ist_2", label: "2. Probe", einheit: "%", modus: "zahl", autoWeiter: true },
  { key: "anf_ist_3", label: "3. Probe", einheit: "%", modus: "zahl", autoWeiter: true },
]
export const LABOR_GRAED: FeldDef[] = [
  { key: "graed_ist_1", label: "1. Probe", einheit: "%", modus: "zahl", autoWeiter: true },
  { key: "graed_ist_2", label: "2. Probe", einheit: "%", modus: "zahl", autoWeiter: true },
  { key: "graed_ist_3", label: "3. Probe", einheit: "%", modus: "zahl", autoWeiter: true },
]
export const ZENTRIFUGE: FeldDef[] = [
  { key: "zykluszeit", label: "Zykluszeit", einheit: "min:sec", modus: "minsek" },
  { key: "auswurfgewicht_kg", label: "Auswurfgewicht", einheit: "kg", modus: "zahl" },
  { key: "fuellgewicht_kg", label: "Füllgewicht", einheit: "kg", modus: "zahl" },
]
export const SOLL: FeldDef[] = [
  { key: "anf_soll", label: "Anfeuchtung Soll", einheit: "%", modus: "zahl" },
  { key: "graed_soll", label: "Grädigkeit Soll", einheit: "%", modus: "zahl" },
]
export const WEITERE: FeldDef[] = [
  { key: "chargen", label: "Chargen", modus: "text" },
  { key: "fass_nr", label: "Fass-Nr.", modus: "text" },
  { key: "rohstoff", label: "Rohstoff", modus: "text" },
  { key: "puelpe", label: "Pülpe", einheit: "mL/L", modus: "zahl" },
  { key: "dauer_wasser_s", label: "Wasser bei 1.450 upm", einheit: "s", modus: "ganz" },
  { key: "drehzahl_1_spriten", label: "1. Spriten", einheit: "upm", modus: "ganz" },
  { key: "dauer_1_abschleudern_s", label: "1. Abschleudern", einheit: "s", modus: "ganz" },
  { key: "drehzahl_1_abschleudern", label: "1. Abschleudern", einheit: "upm", modus: "ganz" },
  { key: "drehzahl_2_spriten", label: "2. Spriten", einheit: "upm", modus: "ganz" },
  { key: "dauer_2_abschleudern_s", label: "2. Abschleudern", einheit: "s", modus: "ganz" },
  { key: "drehzahl_2_abschleudern", label: "2. Abschleudern", einheit: "upm", modus: "ganz" },
  { key: "alkohol_duenn_l", label: "Alkohol dünn", einheit: "L", modus: "zahl" },
  { key: "alkohol_stark_l", label: "Alkohol stark", einheit: "L", modus: "zahl" },
  { key: "tank", label: "Tank", modus: "text" },
  { key: "gehalt", label: "Gehalt", einheit: "%", modus: "zahl" },
]

/** Reihenfolge für „Weiter“: erst Labor, dann Zentrifuge (das, was jedes Mal neu ist). */
export const REIHENFOLGE = [...LABOR_ANF, ...LABOR_GRAED, ZENTRIFUGE[0], ZENTRIFUGE[1]]

export const ALLE_FELDER: FeldDef[] = [...LABOR_ANF, ...LABOR_GRAED, ...ZENTRIFUGE, ...SOLL, ...WEITERE]

export const BEMERKUNGEN = [
  { text: "Testgemisch klar", testgemisch: "klar" },
  { text: "Testgemisch trüb", testgemisch: "trüb" },
  { text: "Spritmenge erhöht" },
  { text: "Drehzahl angepasst" },
  { text: "Probe ans Labor" },
  { text: "Störung" },
] as const

export const MEDIEN = [
  { id: "Ethanol", kurz: "Eth." },
  { id: "IPA", kurz: "IPA" },
  { id: "Wasser", kurz: "wf" },
  { id: "Butanol", kurz: "But" },
]
